/**
 * Bespoke <table> for the Websites card — see Table.module.scss's header
 * comment. No sortable columns (unlike CalendarsPage/Table.jsx, its closest
 * sibling): README doesn't call for sort, and the plan caps this list in
 * single digits.
 */
import React from "react";
import classNames from "classnames";
import TableRow from "./TableRow";
import styles from "./Table.module.scss";

// Column widths live in Table.module.scss (.statusCol/.addedCol/.actionsCol)
// rather than here, so <col> never needs an inline style={{width}}.
const COLUMNS = [
  { key: "domain", label: "Domain" },
  { key: "status", label: "Status" },
  { key: "added", label: "Added" },
];

// README "The card": "Band structure... only the rows band swaps" and,
// for the empty state specifically, "The header, thead and footer bands
// all persist." So an empty list renders as a colSpan row inside the same
// <table>/<thead> rather than replacing the table outright (unlike
// CalendarsPage's EmptyState, which swaps out the whole table).
const WebsitesTable = ({ rows, renderMenu, busyRowId, rowExtra, emptyState }) => (
  <table className={styles.table}>
    <colgroup>
      <col />
      {COLUMNS.slice(1).map((column) => (
        <col
          key={column.key}
          className={column.key === "status" ? styles.statusCol : styles.addedCol}
        />
      ))}
      <col className={styles.actionsCol} />
    </colgroup>
    <thead>
      <tr>
        {COLUMNS.map((column) => (
          <th
            key={column.key}
            scope="col"
            className={classNames(styles.th, {
              [styles.statusCell]: column.key === "status",
              [styles.addedCell]: column.key === "added",
            })}
          >
            {column.label}
          </th>
        ))}
        <th scope="col" className={classNames(styles.th, styles.thActions)}>
          <span className={styles.srOnly}>Actions</span>
        </th>
      </tr>
    </thead>
    <tbody>
      {rows.length === 0 ? (
        <tr>
          <td colSpan={4} className={styles.emptyCell}>
            {emptyState}
          </td>
        </tr>
      ) : (
        rows.map((domain) => (
          <React.Fragment key={domain.uuid}>
            <TableRow
              domain={domain}
              renderMenu={renderMenu}
              isBusy={busyRowId === domain.uuid}
            />
            {rowExtra?.(domain)}
          </React.Fragment>
        ))
      )}
    </tbody>
  </table>
);

export default WebsitesTable;
